import { useGetCheckinSettingsQuery } from '../api/cdnApi'
import { useEventId } from '../app/location'

export default function useEventTimezone() {
  const eventId = useEventId()
  const { data: settingsFromApi, isLoading: isLoadingCheckinSettings } = useGetCheckinSettingsQuery(eventId, {
    skip: !eventId,
  })

  if (!isLoadingCheckinSettings) {
    return settingsFromApi?.event?.timeZone || 'US/Eastern'
  }
}
